import React from 'react'
import { Helmet } from 'react-helmet'

import Layout from '../components/common/Layout'
import { ClientOnly } from '../components/common'
import FirebaseProvider from '../components/idealline/Firebase'
import TelemetrySessionReport from '../components/reports/TelemetrySessionReport'
import '../styles/telemetry-session-report.css'

const TelemetryReportPage = () => (
  <Layout hideFooter bodyClass="telemetry-workspace-page alfano-report-page iracing-telemetry-report">
    <Helmet>
      <title>Private Telemetry Report | Open Racer</title>
      <meta name="robots" content="noindex,nofollow" />
      <meta name="description" content="Your private deterministic telemetry session report." />
    </Helmet>
    <ClientOnly>
      <FirebaseProvider>
        <TelemetrySessionReport />
      </FirebaseProvider>
    </ClientOnly>
  </Layout>
)

export default TelemetryReportPage
